import { ValidationRepository } from "../../domain/repositories/ValidationRepository";
import { ValidationResponse } from "../../domain/entities/ValidationEntity";
import { BillEntity } from "../../domain/entities/BillEntity";
import { validateBillDocument } from "../api/validationApi";

export class ValidationRepositoryImpl implements ValidationRepository {
  async validateBill(
    billData: any,
    billDocument: BillEntity,
    validationType: string = "full_validation"
  ): Promise<ValidationResponse> {
    // Use feature-specific API
    const response = await validateBillDocument(billData, billDocument, validationType);
    return response;
  }
}
